import React from "react";
import { PageContent } from "@redriver/cinnamon";
import { ContentPanel } from "components/displays";
import { BreadcrumbBar } from "pages/nav";

const Zircon = () => {

return(

    <PageContent fluid className="zircon-container">
        <BreadcrumbBar />
        <ContentPanel title="Zircon"   wrapperCssClass="outline-grid" headerCssClass="defaults-page-title">
            <div className="padded">
                Content to go here
            </div>
        </ContentPanel>
    </PageContent>
)};

export default Zircon;